import { render, staticRenderFns } from "./Ventanas.vue?vue&type=template&id=9bb3d344&scoped=true&"
import script from "./Ventanas.vue?vue&type=script&lang=js&"
export * from "./Ventanas.vue?vue&type=script&lang=js&"
import style0 from "./Ventanas.vue?vue&type=style&index=0&id=9bb3d344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb3d344",
  null
  
)

export default component.exports